import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TermsOfService = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        <div className="mb-6">
          <Button variant="ghost" size="sm" className="mb-4" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour
          </Button>
          <h1 className="text-3xl font-bold text-foreground">Conditions Générales d'Utilisation</h1>
          <p className="text-muted-foreground mt-2">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">1. Objet et champ d'application</h2>
            <p className="mb-4">
              Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de l'application "Clan" 
              éditée par Emma Burt, permettant aux familles de s'organiser, gérer leurs événements, tâches et documents.
            </p>
            <p>
              L'utilisation de l'application implique l'acceptation pleine et entière des présentes CGU.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">2. Description du service</h2>
            <p className="mb-4">
              Clan est une application de gestion familiale qui permet de :
            </p>
            <ul className="list-disc list-inside mb-4 ml-4">
              <li>Créer et gérer des profils de membres de la famille</li>
              <li>Organiser des événements et gérer un calendrier partagé</li>
              <li>Créer et assigner des tâches</li>
              <li>Partager des documents et informations</li>
              <li>Inviter de nouveaux membres</li>
              <li>Synchroniser avec Google Calendar</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">3. Inscription et compte utilisateur</h2>
            <p className="mb-4">
              L'inscription nécessite de fournir une adresse email valide et de créer un mot de passe sécurisé.
              L'utilisateur s'engage à fournir des informations exactes et à les maintenir à jour.
            </p>
            <p>
              Chaque utilisateur est responsable de la confidentialité de ses identifiants de connexion.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">4. Utilisation du service</h2>
            <p className="mb-4">
              L'utilisateur s'engage à utiliser l'application de manière conforme à sa destination et aux présentes CGU.
              Il est notamment interdit de :
            </p>
            <ul className="list-disc list-inside mb-4 ml-4">
              <li>Utiliser l'application à des fins illégales ou malveillantes</li>
              <li>Partager du contenu inapproprié, offensant ou illégal</li>
              <li>Tenter de perturber le fonctionnement de l'application</li>
              <li>Usurper l'identité d'une autre personne</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">5. Données personnelles</h2>
            <p>
              Le traitement des données personnelles est régi par notre 
              <Link to="/privacy-policy" className="text-primary hover:underline"> Politique de Confidentialité</Link>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">6. Abonnements et paiements</h2>
            <p className="mb-4">
              Clan propose des fonctionnalités gratuites et des abonnements payants. Les conditions spécifiques 
              aux abonnements (tarifs, durée, modalités de résiliation) sont précisées lors de la souscription.
            </p>
            <p>
              Les paiements sont sécurisés via Stripe. Aucune information bancaire n'est stockée sur nos serveurs.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">7. Propriété intellectuelle</h2>
            <p className="mb-4">
              L'ensemble des éléments de l'application (textes, images, logos, code source) sont protégés par 
              les droits de propriété intellectuelle et appartiennent à Emma Burt.
            </p>
            <p>
              Les contenus créés par les utilisateurs leur appartiennent, mais ils accordent à Emma Burt 
              une licence d'utilisation nécessaire au fonctionnement du service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">8. Responsabilité</h2>
            <p className="mb-4">
              Emma Burt s'efforce d'assurer la disponibilité et la sécurité de l'application, mais ne peut 
              garantir un fonctionnement sans interruption ni défaut.
            </p>
            <p>
              La responsabilité d'Emma Burt ne saurait être engagée en cas de dommages indirects ou de perte de données.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">9. Résiliation</h2>
            <p className="mb-4">
              L'utilisateur peut supprimer son compte à tout moment depuis les paramètres de l'application.
            </p>
            <p>
              Emma Burt se réserve le droit de suspendre ou supprimer un compte en cas de violation des présentes CGU.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">10. Modification des CGU</h2>
            <p>
              Emma Burt se réserve le droit de modifier les présentes CGU à tout moment. 
              Les utilisateurs seront informés des modifications par email ou via l'application.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">11. Droit applicable et juridiction</h2>
            <p>
              Les présentes CGU sont soumises au droit français. Tout litige sera de la compétence 
              exclusive des tribunaux français.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">12. Contact</h2>
            <p>
              Pour toute question concernant ces CGU, vous pouvez nous contacter via l'application 
              ou à l'adresse : contact@get-clan.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;